var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.temaFilial,attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loader-pulse pulse"},[_c('img',{attrs:{"src":'https://'+_vm.clienteSac.endServidor+'/controller/ecommerce/'+_vm.configPathsLogos.logoIcone,"alt":"..."}})]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }